
import {
  TehnicalInspectionSearchFormValues,
  TehnicalInspectionEditFormValues,
  TehnicalInspectionDetailFormValues,
} from "./types";

/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - TEHNICAL INSPECTION SEARCH
---------------------------------------------------------------------------------------------*/
export const initialTehnicalInspectionSearchForm: TehnicalInspectionSearchFormValues =
  {
    search: "",
  };

/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - VEHICLE GROUP DETAIL
---------------------------------------------------------------------------------------------*/

export const initialTehnicalInspectionDetailForm: TehnicalInspectionDetailFormValues =
  {
    id: null,
    vehicleGroupName: null,
    price: null,
  };

/*-------------------------------------------------------------------------------------------
  CALCULATION SETTING - TEHNICAL INSPECTION - EDIT
---------------------------------------------------------------------------------------------*/

export const initialTehnicalInspectionEditForm: TehnicalInspectionEditFormValues =
  {
    vehicleGroupId: "",
    price: null,
  };


